import { Card, Hero, HeroTitle, OrbitMark, SignInPanel, SignInShell, Tagline } from '@components/SignInCard'
import React from 'react'

const LoginPage: React.FC = () => (
	<SignInShell>
		<Card>
			<Hero>
				<HeroTitle>Take your trips out of the group chat.</HeroTitle>
				<Tagline>Plan together, split costs fairly, and actually make the trip happen.</Tagline>

				<OrbitMark />
			</Hero>

			<SignInPanel title="Welcome to Orbit" />
		</Card>
	</SignInShell>
)

export default LoginPage
